// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lang-selector .lang-col[data-v-c9330334]{width:260px}.lang-selector .actions-container[data-v-c9330334]{width:100%;max-width:300px;margin-bottom:50px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
